import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { STATE_DOWNLOAD_URL } from "./gql";

const useDownloadStackState = createDefaultMutationHook(STATE_DOWNLOAD_URL);

export default useDownloadStackState;
